import { Button, Column, Grid } from "@carbon/react";
import { Add } from "@carbon/react/icons";

import { Card, DatePicker, QuickTableFilterTabs } from "..";
import "./_reports-breakdown.scss";

import printIcon from "../../assets/icons/printicon.png";
import downloadIcon from "../../assets/icons/arrowdown.svg";

export const View = (props) => {
  return (
    <Card className="container2 report-breakdown">
      <div className="flex-container report-breakdown--header justify-content--start">
        <div className="flex-box">
          {props.queryStringTabs && (
            <QuickTableFilterTabs
              queryStringTabNavLinks={props.queryStringTabs}
            />
          )}
        </div>

        <div className="flex-container report-filter--container">
          <div className="mr-5">
            <DatePicker startDate="Jun 24" endDate="Jun 31" />
          </div>

          {/* <Button
            size="sm"
            kind="tertiary"
            className="switchapp-themed print"
            iconDescription="Add to balance"
          >
            <img src={printIcon} alt="print document" />
            Print
          </Button> */}
        </div>
      </div>

      <Column sm={4} md={8} lg={16} className="head">
        <Grid>
          <Column sm={4} md={8} lg={15} className="summary">
            <h4 className="font-ctm--bold">
              <strong>{props.subtitle}</strong>
            </h4>
            <p>{props.summary}</p>
          </Column>
          <Column sm={4} md={8} lg={1}>
            <Button
              size="sm"
              kind="tertiary"
              className="switchapp-themed print"
              iconDescription="Download document icon"
            >
              <img src={downloadIcon} alt="download document" />
              Download
            </Button>
          </Column>
        </Grid>
      </Column>

      <Column sm={10} md={8} lg={16} className="head balanceSum">
        <Grid>
          <Column sm={4} md={8} lg={15}>
            <p>{props.detail1}</p>
            <p>{props.detail2}</p>
            <p>{props.detail3}</p>
          </Column>
          <Column sm={4} md={8} lg={1}>
            <p>{props.detail1num}</p>
            <p>{props.detail2num}</p>
            <p>{props.detail3num}</p>
          </Column>
        </Grid>
      </Column>

      <Column Column sm={4} md={8} lg={16} className="parts">
        <Grid>
          <Column sm={4} md={8} lg={15}>
            <p className="font-ctm--semibold">
              <strong>{props.subtitle2}</strong>
            </p>
          </Column>
          <Column sm={4} md={8} lg={1}>
            <p>{props.subtitle2num}</p>
          </Column>
        </Grid>
      </Column>

      <Column Column sm={4} md={8} lg={16}>
        <Grid>
          <Column Column sm={4} md={8} lg={15}>
            <h4 className="font-ctm--bold">
              <strong>{props.subtitle3}</strong>
            </h4>
            <p>{props.subtitle3summary}</p>
            <Grid>
              <Column Column sm={4} md={8} lg={5}>
                <p>{props.row1a}</p>
              </Column>
              <Column Column sm={4} md={8} lg={5}>
                <p>{props.row1b}</p>
              </Column>
              <Column Column sm={4} md={8} lg={3}>
                <p>{props.row1c}</p>
              </Column>
            </Grid>
          </Column>
        </Grid>
        <Column className="darks">
          <Grid>
            <Column sm={4} md={8} lg={5}>
              &nbsp;
            </Column>
            <Column sm={4} md={8} lg={4}>
              <p>{props.row2b}</p>
            </Column>
            <Column sm={4} md={8} lg={6}>
              &nbsp;
            </Column>
            <Column sm={4} md={8} lg={1}>
              <p>{props.row2c}</p>
            </Column>
          </Grid>
        </Column>
        <Column className="rows">
          <Grid>
            <Column sm={4} md={8} lg={5}>
              {props.row3a}
            </Column>
            <Column sm={4} md={8} lg={5}>
              {props.row3b}
            </Column>
            <Column sm={4} md={8} lg={5}>
              {props.row3c}
            </Column>
            <Column sm={4} md={8} lg={1}>
              {props.row3d}
            </Column>
          </Grid>
        </Column>
        <Column className="darks rows">
          <Grid>
            <Column sm={4} md={8} lg={5}>
              &nbsp;
            </Column>
            <Column sm={4} md={8} lg={5}>
              {props.row4b}
            </Column>
            <Column sm={4} md={8} lg={5}>
              &nbsp;
            </Column>
            <Column sm={4} md={8} lg={1}>
              {props.row4c}
            </Column>
          </Grid>
        </Column>
        <Column className="rows row2">
          <Grid>
            <Column sm={4} md={8} lg={5}>
              <h5 className="font-ctm--semibold">
                <strong>{props.balanceactivity}</strong>
              </h5>
            </Column>
            <Column sm={4} md={8} lg={5}>
              &nbsp;
            </Column>
            <Column sm={4} md={8} lg={5}>
              {props.activitynum}
            </Column>
            <Column sm={4} md={8} lg={1}>
              <strong> {props.activityamount}</strong>
            </Column>
          </Grid>
        </Column>

        <Grid>
          <Column sm={4} md={8} lg={15} className="rows">
            <h4 className="font-ctm--bold">
              <strong>{props.subtitle4}</strong>
            </h4>
            <p>{props.subtitle4summary}</p>
          </Column>
          <Column sm={4} md={8} lg={1}>
            <Button
              size="sm"
              kind="tertiary"
              className="switchapp-themed print"
              iconDescription="Download document icon"
            >
              <img src={downloadIcon} alt="download document" />
              Download
            </Button>
          </Column>
        </Grid>

        <Grid>
          <Column sm={4} md={8} lg={5}>
            <p>{props.row6a}</p>
          </Column>
          <Column sm={4} md={8} lg={5}>
            <p>{props.row6b}</p>
          </Column>
          <Column sm={4} md={8} lg={5}>
            <p>{props.row6c}</p>
          </Column>
        </Grid>
        <Column className="darks">
          <Grid>
            <Column sm={4} md={8} lg={5}>
              &nbsp;
            </Column>
            <Column sm={4} md={8} lg={9}>
              <p>{props.row7a}</p>
            </Column>
            <Column sm={4} md={8} lg={2}>
              <p>{props.row7b}</p>
            </Column>
          </Grid>
        </Column>
      </Column>
    </Card>
  );
};
